module.exports = __webpack_public_path__ + "img/home-ico.049f6256.svg";